import LocationServicesContainer from './LocationServicesContainer';

export default LocationServicesContainer;
